<template>
    <tr>
        <td>
            <input type="text" :placeholder="$t('dispute.sn')" class="form-control" v-model="product.sn" />
        </td>
        <td>
            <textarea :placeholder="$t('dispute.mistake')" class="form-control" v-model="product.mistake"></textarea>
        </td>
        <td class="d-none">
            <select v-model="product.wish" class="custom-select my-1 mr-sm-2">
                <option v-for="wish in wishes" :value="wish.id">{{wish.description}}</option>
            </select>
        </td>
        <td>
            <!-- Picture adder -->
            <div>
                <div @mouseenter="popIt" @mouseleave="popIt" id="hover-container">
                    <div v-if="showPics" class="popover images">
                        <div v-key="pic.path" v-for="pic in product.pictures">
                            <img class="img-fluid" :src="pic.url" :alt="pic.path">
                        </div>
                    </div>
                    <div class="uploader">
                        <input type="file" name="image" :disabled="loading"
                                        accept="image/*" class="input-file" @change="uploadImage($event)">
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    data() {
        return {
            payload: '',
            loading: false,
            image: Object,
            showPics: false,
            checked: false,
            pictures: [],
        }
    },
    props: {
        wishes: {
            type: Array,
            default: () => {
                return [];
            },
        },
        product: {
            type: Object,
            default: () => {
                return {
                    sn: '',
                    checked: false,
                    order_code: '',
                    pictures: [],
                    mistake: '',
                    wish: '',
                }
            },
        },
    },
    methods: {
        popIt: function(){
            this.showPics = !this.showPics;
        },
        uploadImage: function(event){

            let formData = new FormData();
            formData.append('image', event.target.files[0]);
            this.loading = true;
            axios.post('/dashboard/dispute_picture', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }}).then(response => {
                    console.log(response.data);
                    this.pictures.push(response.data);

                    this.$set(this.product, 'pictures', this.pictures)
                    this.loading = false;
                });
        },
        checkChecked(){
            this.product.checked = this.checked;
        }
    }
}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';

#hover-container{
    height: 100%;
    position: relative;
}
.popover.images{
    padding: 0.2em;
    border-radius: 5px;
    border: 1px solid $lightgrey;
    position: absolute;
    top: 50px;
    .img-fluid {
        height: 100px;
    }
}
</style>
